<template>
  <span
    class="whitespace-nowrap rounded-full bg-opacity-20 px-3 py-1 text-xs font-medium"
    :class="[`bg-${meta.color}`, `text-${meta.color}`]"
  >
    {{ meta.label }}
  </span>
</template>

<script setup lang="ts">
import {
  STORAGE_STATE_META,
  type StorageMarkerState,
} from "@/services/storage/storage";

const props = defineProps<{ state: StorageMarkerState }>();

const meta = computed(() => STORAGE_STATE_META[props.state]);
</script>
